import { Enum } from './Enum';

export class MemberPhoneInvalidateReason extends Enum {
  translationKey = 'memberPhoneInvalidateReason';

  static asArray: MemberPhoneInvalidateReason[] = [];

  static byKey: { [name: string]: MemberPhoneInvalidateReason } = {};

  static readonly DISCONNECTED = new MemberPhoneInvalidateReason(
    'DISCONNECTED',
  );

  static readonly FAMILY = new MemberPhoneInvalidateReason('FAMILY');

  static readonly OTHER = new MemberPhoneInvalidateReason('OTHER');

  constructor(public readonly value: string) {
    super();
    MemberPhoneInvalidateReason.asArray.push(this);
    MemberPhoneInvalidateReason.byKey[value] = this;
  }
}

export default MemberPhoneInvalidateReason;
